import { UsageTermPage, PrivacyTermPage, HomePage } from 'pages';

export default [
  { path: '/agreements/usage', component: UsageTermPage },
  { path: '/agreements/privacy', component: PrivacyTermPage },
  { path: '/', component: HomePage, exact: true },
];
